(function ($, angular, _, window) {
    'use strict';

    window.THF.Angular.LiveQuoteTool.directive('thfLeadGeneration', ['$timeout', '$sce', 'QuoteEmailModel','CallbackRequestModel', function ($timeout, $sce, QuoteEmailModel, CallbackRequestModel) {
        var link = function (scope, el) {
            scope.icon = {
                radialDefault: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-default', viewBox: '0 0 32 32.01' },
                radialChecked: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-filled', viewBox: '0 0 32 32.01' },
            };
            scope.show = {
                sendEmailPanel: false,
                requestCallbackPanel: false,
                confirmationPanel: false,
                requestSubmitting: false,
                requestError: false
            };
            
            scope.settings = {
                siteName: liveQuoteToolPageData.siteName,
                contactNumber: liveQuoteToolPageData.contactNumber,
                ui: {
                    interactionTimeout: 15
                }
            };
            
            scope.state = {
                uiTimer: null,
                timeSinceLastInteraction: 0,
                interactionPause: false,

                /*
                Used to display an appropriate thank you, based on user actions
                Must be string, only two valid values (as detected in view):
                If user has emailed a quote: 'quote-email'
                if user requested callback: 'callback-request'
                 */
                // submissionType: 'quote-email'
                // submissionType: 'callback-request'
                submissionType: null  
            };

            scope.defaultModel = {
                firstName: '',
                lastName: '',
                email: '',
                optionalPhoneNumber: [
                    {
                        'type': 'mobile',
                        'value': ''
                    }
                ],
                isMember: '',
            };

            scope.model = angular.copy(scope.defaultModel);

            // scope.model = {
            //     firstName: 'test',
            //     lastName: 'test',
            //     email: 'test@test.com',
            //     phoneNumber: [
            //         {
            //             "type": "mobile",
            //             "value": "0410000000"
            //         },
            //         {
            //             "type": "office",
            //             "value": "0289170000"
            //         },
            //         {
            //             "type": "home",
            //             "value": "0243620000"
            //         }
            //     ],
            //     isMember: 'Y',
            //     chatWithUs: 'Y'
            // };
            
            scope.field = {
                'firstName': {
                    'label': 'First Name *',
                    'labelStyle': '',
                    'name': 'firstName',
                    'defaultValue': '',
                    'placeholder': '',
                    'maxLength': 16
                },
                'lastName': {
                    'label': 'Last Name *',
                    'labelStyle': '',
                    'name': 'lastName',
                    'defaultValue': '',
                    'placeholder': '',
                    'maxLength': 25
                },
                'email': {
                    'label': 'Email Address *',
                    'labelStyle': '',
                    'name': 'email',
                    'defaultValue': '',
                    'placeholder': ''
                },
                'phoneNumber': {
                    'label': 'Phone Number *',
                    'labelStyle': '',
                    'name': 'phoneNumber',
                    'defaultValue': [
                        {
                            'type': 'mobile',
                            'value': ''
                        }
                    ],
                    'placeholder': ''
                },
                'optionalPhoneNumber': {
                    'label': 'Phone Number (Optional)',
                    'labelStyle': '',
                    'name': 'optionalPhoneNumber',
                    'defaultValue': [
                        {
                            'type': 'mobile',
                            'value': ''
                        }
                    ],
                    'placeholder': ''
                },
                'isMember': {
                    'label': 'Do you already have cover with '+scope.settings.siteName+'? *',
                    'labelStyle': '',
                    'name': 'isMember',
                    'defaultValue': '',
                    'placeholder': '',
                    'tooltip': '',
                    'options': [
                        {'label': 'Yes', 'value': 'Y'},
                        {'label': 'No', 'value': 'N'}
                    ]
                }
            };
            scope.validation = {};
            scope.validationRules = {
                quoteEmail: {
                    'firstName': [
                        'required'
                    ],
                    'lastName': [
                        'required'
                    ],
                    'email': [
                        'required',
                        'thfEmail'
                    ],
                    'phoneNumber': [
                        'required',
                        'requiredPhoneNumber'
                    ],
                    'isMember': [
                        'required'
                    ]
                },
                callback: {
                    'firstName': [
                        'required'
                    ],
                    'lastName': [
                        'required'
                    ],
                    'email': [
                        'required',
                        'thfEmail'
                    ],
                    'phoneNumber': [
                        'required',
                        'requiredPhoneNumber'
                    ],
                    'isMember': [
                        'required'
                    ]
                }
            };

            scope.toggleSendEmailPanel = function ($event) {
                debugLog('showSendEmailPanel()');
                
                scope.interaction();
                
                var leadCapture = document.querySelector('.lead-capture');
                
                var isPanelOpen = scope.show.sendEmailPanel;
                if (isPanelOpen) {
                    scope.show.sendEmailPanel = false;
                    scope.show.requestError = false;
                    
                    if(window.innerWidth < 768) {
                        window.document.body.style.overflow = 'auto';
                        if(leadCapture != null) {
                            leadCapture.classList.remove('mobile');
                        }
                    }
                } else {
                    scope.show.sendEmailPanel = true;
                    scope.validation = {};

                    if(window.innerWidth < 768) {
                        window.document.body.style.overflow = 'hidden';
                        if(leadCapture != null) {
                            leadCapture.classList.add('mobile');
                        }
                    }
                }

                if($event){
                    $event.preventDefault();
                }
            };
            
            scope.toggleRequestCallbackPanel = function ($event) {
                debugLog('toggleRequestCallbackPanel()');

                scope.interaction();

                var leadCapture = document.querySelector('.lead-capture');
                
                var isPanelOpen = scope.show.requestCallbackPanel;
                if (isPanelOpen) {
                    scope.show.requestCallbackPanel = false;
                    scope.show.requestError = false;
                    if(window.innerWidth < 768) {
                        window.document.body.style.overflow = 'auto';
                        if(leadCapture != null) {
                            leadCapture.classList.remove('mobile');
                        }
                    }
                } else {
                    scope.show.requestCallbackPanel = true;
                    scope.validation = {};
                    
                    if(window.innerWidth < 768) {
                        window.document.body.style.overflow = 'hidden';
                        if(leadCapture != null) {
                            leadCapture.classList.add('mobile');
                        }
                    }
                }

                if($event){
                    $event.preventDefault();
                }
            };

            scope.toggleConfirmationPanel = function ($event) {
                debugLog('toggleConfirmationPanel()');
                if (typeof $event !== 'undefined') {
                    $event.preventDefault();
                }

                var leadCapture = document.querySelector('.lead-capture');
                
                if(window.innerWidth < 768) {
                    window.document.body.style.overflow = 'auto';
                    if(leadCapture != null) {
                        leadCapture.classList.remove('mobile');
                    }
                }
                
                //Hide processing state
                scope.show.requestSubmitting = false;

                scope.show.sendEmailPanel = false;
                scope.show.requestCallbackPanel = false;
                scope.show.confirmationPanel = true;
                scope.show.requestError = false;
                
                scope.interaction();
            };
            
            scope.validate = function(formValidationRules) {
                scope.validation = {};
                var validationResponse = {
                    result: true
                };
                for(var key in formValidationRules) {
                    if(formValidationRules.hasOwnProperty(key)) {
                        var fieldValidationRules = formValidationRules[key];
                        var field = scope.field[key];
                        for(var i = 0; i < fieldValidationRules.length; i++) {
                            var fieldValid = THF.Utility.Validation.validateRule(fieldValidationRules[i], scope.model[key], '', {
                                field: field
                            });
                            if(!fieldValid.result) {
                                validationResponse.result = false;
                                scope.validation[key] = fieldValid
                            }
                        }
                        
                    } 
                }
                
                return validationResponse;
            }

            scope.setFocusToInvalidField = function(formName){
                setTimeout(function(){
                    var errorDivEls = document.querySelectorAll("form[name='" + formName + "'] .field-validation-error:not(.ng-hide)");

                    if (errorDivEls.length > 0) {
                        var errorDivEl = errorDivEls[0];
                        var inputEl = errorDivEl.parentElement.querySelector("input.input-validation-error");

                        if (!inputEl) {
                            inputEl = errorDivEl.parentElement.querySelector(".input-validation-error input");
                        }

                        if (!inputEl) {
                            inputEl = errorDivEl.parentElement.querySelector("input");
                        }

                        if (inputEl) {
                            inputEl.focus();
                        }
                    }

                }, 100);
            }

            scope.trackSuccess = (formInstance) => {
                window.VWO = window.VWO || [];
                window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 1]);
            }

            scope.trackFailure = (formInstance) => {
                window.VWO = window.VWO || [];
                window.VWO.push(['nls.formAnalysis.markSuccess', formInstance, 0]);
            }
            
            scope.sendQuoteEmail = function (form) {
                scope.interaction();
                
                debugLog('sendQuoteEmail');
                var validationRules = scope.validationRules.quoteEmail;
                
                var validationResponse = scope.validate(validationRules);
                if(!validationResponse.result) {
                    scope.setFocusToInvalidField("formEmail");
                    return;    
                }

                scope.interactionPause();
                
                // Show processing state
                scope.show.requestSubmitting = true;

                var parentScope = scope.$parent;
                
                // Generate URL
                var otherQueryVars = {
                    asAtDateApril: parentScope.model.asAtDateApril,
                    rebateTier: parentScope.model.income,
                    extended: parentScope.model.extended,
                    frequency: parentScope.quotePanel.value.frequency
                };

                var url = THF.Utility.Location.generateLiveQuoteToolShareUrl(
                    parentScope.model.state,
                    parentScope.model.coverType,
                    parentScope.model.hospitalType,
                    parentScope.model.extrasType,
                    parentScope.model.age,
                    otherQueryVars
                );
                
                var queryParams = {
                    //User supplied values
                    firstName: scope.model.firstName,
                    lastName: scope.model.lastName,
                    email: scope.model.email,
                    isMember: scope.model.isMember,
                    mobilePhone: scope.getPhone('mobile'),
                    homePhone: scope.getPhone('home'),
                    workPhone: scope.getPhone('office'),

                    membershipType: parentScope.quotePanel.value.coverType,
                    hospitalCover: parentScope.quotePanel.text.hospitalCover,
                    extrasCover: parentScope.quotePanel.text.extrasCover,
                    state: getDropdownLabel(parentScope.quotePanel.dropdowns.state, parentScope.model.state),

                    price: parentScope.quotePanel.value.price,
                    frequency: parentScope.quotePanel.value.frequency,
                    excess: parentScope.quotePanel.value.excess,
                    lhcPercentage: parentScope.quoteData.lifetimeHealthCoverPercentage,
                    rebatePercentage: parentScope.quoteData.rebatePercentage,
                    quoteLink: url,
                    hrc: THF.Utility.HealthRateCode.encode(parentScope.model.state, getCoverType(), parentScope.model.hospitalType, parentScope.model.extrasType),
                    utm: THF.Interface.CampaignCapture.getCapturedQueryString(),
                    incomeTier: parseInt(parentScope.model.income)
                };
                
                QuoteEmailModel.send(queryParams)
                    .then(function (response) {
                        var formInstance = document.querySelector('form[name="formEmail"]');
                        scope.trackSuccess(formInstance);
                        scope.interactionResume();
                        scope.state.submissionType = 'quote-email';
                        scope.toggleConfirmationPanel();
                    }).catch(function(error) {
                        var formInstance = document.querySelector('form[name="formEmail"]');
                        scope.trackFailure(formInstance);
                        scope.interactionResume();
                        scope.show.requestSubmitting = false;
                        scope.show.requestError = true;
                    });
            };

            scope.sendCallbackRequestEmail = function (form) {
                scope.interaction();
                
                debugLog('sendCallbackRequestEmail');
                var validationRules = scope.validationRules.callback;
                
                // Not needed for callback.
                // if (scope.model.chatWithUs === 'N') {
                //     scope.model.phoneNumber = []; 
                //     validationRules.phoneNumber = [];
                // }
                // else {
                //     validationRules.phoneNumber = [
                //         'required',
                //         'requiredPhoneNumber'
                //     ];
                // }
 
                var validationResponse = scope.validate(validationRules);
                if(!validationResponse.result) {
                    scope.setFocusToInvalidField("formCallback");
                    return;
                }

                scope.interactionPause();

                // Show processing state
                scope.show.requestSubmitting = true;

                var parentScope = scope.$parent;
                
                // Generate URL
                var otherQueryVars = {
                    asAtDateApril: parentScope.model.asAtDateApril,
                    rebateTier: parentScope.model.income,
                    extended: parentScope.model.extended,
                    frequency: parentScope.quotePanel.value.frequency
                };

                var url = THF.Utility.Location.generateLiveQuoteToolShareUrl(
                    parentScope.model.state,
                    parentScope.model.coverType,
                    parentScope.model.hospitalType,
                    parentScope.model.extrasType,
                    parentScope.model.age,
                    otherQueryVars
                );

                var queryParams = {

                    // User supplied values
                    firstName: scope.model.firstName,
                    lastName: scope.model.lastName,
                    mobilePhone: scope.getPhone('mobile'),
                    homePhone: scope.getPhone('home'),
                    workPhone: scope.getPhone('office'),
                    email: scope.model.email,
                    isMember: scope.model.isMember,

                    membershipType: parentScope.quotePanel.value.coverType,
                    hospitalCover: parentScope.quotePanel.text.hospitalCover,
                    extrasCover: parentScope.quotePanel.text.extrasCover,
                    state: getDropdownLabel(parentScope.quotePanel.dropdowns.state, parentScope.model.state),

                    price: parentScope.quotePanel.value.price,
                    frequency: parentScope.quotePanel.value.frequency,
                    excess: parentScope.quotePanel.value.excess,
                    lhcPercentage: parentScope.quoteData.lifetimeHealthCoverPercentage,
                    rebatePercentage: parentScope.quoteData.rebatePercentage,
                    quoteLink: url,
                    hrc: THF.Utility.HealthRateCode.encode(parentScope.model.state, getCoverType(), parentScope.model.hospitalType, parentScope.model.extrasType),
                    utm: THF.Interface.CampaignCapture.getCapturedQueryString()
                };
                

                // jquery????
                // var queryString = $.param(queryParams);

                CallbackRequestModel.send(queryParams)
                    .then(function (response) {
                        var formInstance = document.querySelector('form[name="formCallback"]');
                        scope.trackSuccess(formInstance);
                        scope.interactionResume();
                        scope.state.submissionType = 'callback-request';
                        scope.toggleConfirmationPanel();
                    }).catch(function(error) {
                        var formInstance = document.querySelector('form[name="formCallback"]');
                        scope.trackFailure(formInstance);
                        scope.interactionResume();
                        scope.show.requestSubmitting = false;
                        scope.show.requestError = true;
                    });
            };
            
            scope.getPhone = function(type) {
                // Check if phoneNumber values are empty
                var isPhoneNumberEmpty = !scope.model.phoneNumber || scope.model.phoneNumber.every(function(item) {
                    return !item.value || item.value.trim() === '';
                });

                // If phoneNumber is empty, use optionalPhoneNumber
                var phoneArray = isPhoneNumberEmpty ? scope.model.optionalPhoneNumber : scope.model.phoneNumber;

                // Find the phone of the specified type (mobile, home, office)
                if(phoneArray instanceof Array) {
                    var byType = phoneArray.filter(function(item) {
                        return item.type === type;
                    });
                    if(byType.length > 0) {
                        return byType[0].value;
                    }
                }

                return '';
            };

            /*
            UI Timer + interaction methods
             */

            scope.$watch('model', function () {
                debugLog('model updated');
                scope.interaction();
            }, true);

            scope.interaction = function () {
                debugLog('interaction');
                scope.state.timeSinceLastInteraction = 0;
            };

            scope.uiTimer = null;

            scope.interactionPause = function () {
                debugLog('pause interaction');
                scope.state.timeSinceLastInteraction = 0;
                scope.state.interactionPause = true;
            }
            scope.interactionResume = function () {
                debugLog('resume interaction');
                scope.state.timeSinceLastInteraction = 0;
                scope.state.interactionPause = false;
                
            }
            
            scope.interactionTimer = function () {
                debugLog('interactionTimer');
                // Keep the second timer ticking over.
                scope.state.uiTimer = $timeout(scope.interactionTimer, 1000);
                
                // If the interaction is paused then dont process the following logic.
                if(scope.state.interactionPause) {
                    debugLog('interaction paused');
                    return;
                }
                
                // Increment the timer.
                scope.state.timeSinceLastInteraction++;
                
                // If the timer has reached its timeout, trigger the functionality to close down panels.
                if (scope.state.timeSinceLastInteraction >= scope.settings.ui.interactionTimeout) {
                    debugLog('interactionTimer - timeout');

                    // If email confirmation panel is open, lets close it
                    if (scope.show.confirmationPanel === true) {
                        scope.show.confirmationPanel = false;
                        scope.state.submissionType = null;
                    }
                    // reset the interaction
                    scope.state.timeSinceLastInteraction = 0;
                }
            };

            // Disabled timer that closes the modal - THFM-1320
            // BB-2024-10-15 - Re-added but modified the timer so that it only removes the confirmation message, rather than the forms.
            // The issue with disabling completely, means you can only perform this action once and have to choose between
            // callback or email, not both...
            scope.interactionTimer();


            /*
            END
            2021 Amends - THFM-707
             */

            function getCoverType() {
                var coverType = scope.$parent.model.coverType;
                if (scope.$parent.model.extended) {
                    if (coverType === 'Fam') {
                        coverType = 'FamX';
                    }
                    else if (coverType === 'SPFam') {
                        coverType = 'SPFamX';
                    }
                }
                return coverType;
            }
            
            function getDropdownLabel(dropdown, value) {
                debugLog('getDropdownLabel()');
                var values = _.filter(dropdown, { value: value });
                if (typeof values[0] !== 'undefined' && typeof values[0].label !== 'undefined') {
                    return values[0].label;
                }
                return '';
            };

            function debugLog(msg) {
                if (window.THFLogging === true) {
                    if (console && console.log) {
                        console.log('[LeadGeneration]', msg);
                    }
                }
            }
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
            },
            'link': link,
            'templateUrl': function () {
                return THF.Utility.Location.cacheBustUrl('/static/views/live-quote-tool/leadGeneration.html');
            }
        };
    }]);
})(jQuery, angular, _, window);
